import React from "react";
import tw from "twin.macro";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import BgTitle from "components/title/BgTitle";
import reinforcementImg from "../../images/reinforcement/construction.png";

const TwoColumn = tw.div`flex flex-col md:flex-row justify-between max-w-screen-xl mx-auto py-20 md:py-24`;
const Column = tw.div`w-full max-w-md mx-auto md:max-w-none md:mx-0`;
const ImageColumn = tw(
  Column
)`md:w-6/12 lg:w-5/12 flex-shrink-0 h-auto md:h-auto`;
const TextColumn = styled(Column)((props) => [
  tw`md:w-6/12 mt-4 md:mt-0`,
  props.textOnLeft
    ? tw`md:mr-8 lg:mr-16 md:order-first`
    : tw`md:ml-8 lg:ml-16 md:order-last`,
]);

const Image = styled.div((props) => [
  `background-image: url("${props.imageSrc}");`,
  tw`rounded bg-cover bg-center h-full`,
]);
const TextContent = tw.div`lg:py-4`;

const Statistics = tw.div`flex flex-wrap items-center`;
const Statistic = tw.div`text-lg w-1/2 mt-4 lg:mt-10 text-center md:text-left`;
const Value = tw.div`text-sm text-ncc`;
const Key = tw.div`font-bold text-sm text-gray-700`;

export default ({ textOnLeft = false }) => {
  const { t } = useTranslation();
  const jccInfo = t("reinforcementDetails.jccInfo", { returnObjects: true });

  return (
    <TwoColumn>
      <ImageColumn>
        <Image imageSrc={reinforcementImg} />
      </ImageColumn>
      <TextColumn textOnLeft={textOnLeft}>
        <TextContent>
          <BgTitle text={jccInfo.title + " " + jccInfo.description} />
          {/* <Description>{jccInfo.description}</Description> */}
          <Statistics>
            {jccInfo.statistics.map((statistic, index) => (
              <Statistic key={index}>
                <Key>
                  {statistic.key}&nbsp;
                  <i
                    style={{ fontSize: "1rem" }}
                    className={`fa-solid ${statistic.icon}`}
                  ></i>
                </Key>
                <Value>
                  {statistic.key === "Link:" || statistic.key === "リンク：" ? (
                    <a
                      href={statistic.value}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{
                        color: "inherit",
                        textDecoration: "none",
                      }}
                    >
                      {statistic.value}
                    </a>
                  ) : (
                    <div>
                      {statistic.value1}
                      <br />
                      {statistic.value2}
                    </div>
                  )}
                </Value>
              </Statistic>
            ))}
          </Statistics>
        </TextContent>
      </TextColumn>
    </TwoColumn>
  );
};
